export namespace Enums {
  export enum PMS {
    DENTALLY = "DENTALLY",
    EXACT = "EXACT",
  }
  export enum API_ERROR_TYPES {
    FORBIDDEN = "FORBIDDEN",
    UNAUTHORIZED = "UNAUTHORIZED",
    CUSTOM = "CUSTOM",
    SERVER_ERROR = "SERVER_ERROR",
    HTTP_ERROR = "HTTP_ERROR",
  }

  export enum E_CRON_DAYS {
    MON = 1,
    TUE = 2,
    WED = 3,
    THU = 4,
    FRI = 5,
    SAT = 6,
    SUN = 7,
  }

  export enum E_Signature_Mode {
    TYPE = "TYPE",
    DRAW = "DRAW",
  }

  export enum E_MESSAGE_TYPES {
    PORTAL_APPOINTMENT_BOOKING_CONFIRMATION = "portal_appointment_booking_confirmation",
    PORTAL_APPOINTMENT_CANCELLATION_CONFIRMATION = "portal_appointment_cancellation_confirmation",
    PORTAL_PATIENT_2FA = "portal_patient_2fa",
    PORTAL_TASK_REMINDER = "portal_task_reminder",
  }
}
